export default __webpack_public_path__ + "static/step_04-b49f7de59f87e8d1b929dc1c79cdad96.png";